<template>
  <!-- eslint-disable max-len -->
  <svg
    class="x-icon x-icon-lg"
    :class="`${animationClass} ${fillClass}`"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.32417 8.8798C2.09008 10.6403 2.41333 12.43 3.24852 13.9973C4.08371 15.5647 5.38888 16.8311 6.98073 17.6187C8.57258 18.4063 10.3711 18.6754 12.1238 18.3884C13.8765 18.1013 15.4952 17.2725 16.7527 16.0183C18.0101 14.7641 18.8431 13.1475 19.1347 11.3956C19.4263 9.64363 19.1617 7.84438 18.3783 6.25051C17.5948 4.65663 16.3318 3.3482 14.7665 2.50897C13.2013 1.66974 11.4125 1.34188 9.6514 1.57143C9.24066 1.62496 8.86429 1.33539 8.81076 0.924655C8.75722 0.513916 9.04679 0.137546 9.45753 0.0840098C11.5294 -0.186045 13.6339 0.199675 15.4753 1.187C17.3168 2.17433 18.8027 3.71366 19.7244 5.58881C20.6461 7.46396 20.9574 9.58072 20.6143 11.6418C20.2713 13.7029 19.2913 15.6048 17.812 17.0803C16.3326 18.5559 14.4282 19.531 12.3662 19.8687C10.3043 20.2064 8.18833 19.8897 6.31557 18.9632C4.4428 18.0366 2.90731 16.5467 1.92473 14.7027C0.942152 12.8587 0.561857 10.7533 0.837253 8.68209C0.891848 8.27149 1.26896 7.98289 1.67956 8.03749C2.09016 8.09208 2.37876 8.4692 2.32417 8.8798Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
interface Props {
  animationClass?: string
  fillClass?: string
}
withDefaults(defineProps<Props>(), {
  animationClass: 'x-animate-spin',
  fillClass: 'x-text-neutral-0',
})
</script>
